import { Component } from '@angular/core';

@Component({
  selector: 'startup-loading',
  template: `
    <div id="app-introduction" class="flex-center">
      <div class="loader">Loading...</div>
    </div>
  `,
})
export class StartupLoadingComponent {}
